import Vue from 'vue'
import Router from 'vue-router'

// components
import Home from '@/components/Home.vue'
import Members from '@/components/Members.vue'
import MembersDetail from '@/components/MembersDetail.vue'
import Access from '@/components/Access.vue'
import Research from '@/components/Research.vue'
import Publications from '@/components/Publications.vue'
import Facility from '@/components/Facility.vue'
import PersonalityEstimation from '@/components/PersonalityEstimation.vue'
import R1 from '@/components/researches/R1.vue'
import R2 from '@/components/researches/R2.vue'
import R3 from '@/components/researches/R3.vue'
import R4 from '@/components/researches/R4.vue'
import R5 from '@/components/researches/R5.vue'
import R6 from '@/components/researches/R6.vue'
import Schedule from '@/components/researches/Schedule.vue'
import Voice from '@/components/Voice.vue'
import Question from '@/components/Question.vue'
import Login from '@/Login.vue'
import Description from '@/components/researches/Description.vue'

import information from '@/components/data/information.js'


Vue.use(Router)

let routes = [
    {
        path: '/', redirect: '/home'
    },
    {
        path: '/home',
        name: 'home',
        component: Home
    },
    /*
    {
        path: '/works',
        name: 'works',
        component: Works
    },
    */
    {
        path: '/members',
        name: 'members',
        component: Members
    },
    {
        path: '/members/:user_name',
        name: 'members_detail',
        component: MembersDetail
    },
    {
        path: '/access',
        name: 'access',
        component: Access
    },
    {
        path: '/research',
        name: 'research',
        component: Research
    },
    {
        path: '/publications',
        name: 'publications',
        component: Publications
    },
    {
        path: '/facility',
        name: 'facility',
        component: Facility
    },
    {
        path: '/voice',
        name: 'voice',
        component: Voice
    },
    {
        path: '/question',
        name: 'question',
        component: Question
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/personality_estimation',
        name: 'personality_estimation',
        component: PersonalityEstimation
    },
    {
        path: '/research/1',
        name: 'research_1',
        component: R1
    },
    {
        path: '/research/2',
        name: 'research_2',
        component: R2
    },
    {
        path: '/research/3',
        name: 'research_3',
        component: R3
    },
    {
        path: '/research/4',
        name: 'research_4',
        component: R4
    },
    {
        path: '/research/5',
        name: 'research_5',
        component: R5
    },
    {
        path: '/research/6',
        name: 'research_6',
        component: R6
    },
    {
        path: '/research/schedule',
        name: 'schedule',
        component: Schedule
    },
    {
        path: '/research/description',
        name: 'description',
        component: Description
    },
]

// information.js からルートを生成して追加
information.infos.forEach(info => {
    routes.push({
      path: info.link,
      name: `${info.date}`, // 動的なルート名を生成
      component: () => import(`@/components/archive/${info.date}.vue`) // 動的なコンポーネントの読み込み
    })
  })

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior (to, from, savedPosition) { // ページ遷移時に画面トップに戻す
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})